import './spinner.scss';
import PropTypes from 'prop-types';

function Loading({ text }) {
    return (
        <div className='layout-box'>
            <div className='loading'>
                <div className='effect-1 effects'></div>
                <div className='effect-2 effects'></div>
                <div className='effect-3 effects'></div>
            </div>
            <h5 className='title'>{text}...</h5>
        </div>
    )
}

Loading.propTypes = {
    text: PropTypes.string
}

Loading.defaultProps = {
    text: 'Initialising'
};

export default Loading;
